<ng-container *ngIf="cardToken$ | async as cardToken; else addCard">
  <div
    class="ecash-button d-flex justify-content-between align-item-center bg-glass"
    [ngClass]="{
      'bg-frozen': cardToken.Frozen,
      'member-card-button': isMemberCard,
      'non-member-button bg-primary': !isMemberCard,
    }"
  >
    <div class="card-token-number">
      <ng-container [ngSwitch]="cardToken.CardType">
        <img
          *ngSwitchCase="1"
          [ngClass]="{ 'payment-logo': isMemberCard, 'ecash-logo': !isMemberCard }"
          [src]="'payment-icons/mastercard.svg' | contentAssetImage"
        />
        <img
          *ngSwitchCase="2"
          [ngClass]="{ 'payment-logo': isMemberCard, 'ecash-logo': !isMemberCard }"
          [src]="'payment-icons/amex.svg' | contentAssetImage"
        />
        <img
          *ngSwitchCase="3"
          [ngClass]="{ 'payment-logo': isMemberCard, 'ecash-logo': !isMemberCard }"
          [src]="'payment-icons/visa.svg' | contentAssetImage"
        />
        <img
          *ngSwitchCase="4"
          [ngClass]="{ 'payment-logo': isMemberCard, 'ecash-logo': !isMemberCard }"
          [src]="'payment-icons/discover.svg' | contentAssetImage"
        />
        <img
          *ngSwitchCase="5"
          [ngClass]="{ 'payment-logo': isMemberCard, 'ecash-logo': !isMemberCard }"
          [src]="'payment-icons/jcb.svg' | contentAssetImage"
        />
        <img
          *ngSwitchCase="8"
          [ngClass]="{ 'payment-logo': isMemberCard, 'ecash-logo': !isMemberCard }"
          [src]="'payment-icons/unionpay.svg' | contentAssetImage"
        />
      </ng-container>
      <span class="mx-2"> ({{ cardToken?.CardNumber | creditCardNumber | slice: 15 }}) </span>
      <ng-container> Exp:{{ cardToken?.ExpiryDate | date: 'MM/yy' }} </ng-container>
    </div>
    <div class="d-flex align-items-center">
      <div
        class="expiried-status bg-white rounded py-1 px-3 fw-normal font-size-12 text-danger"
        *ngIf="isExpiried(cardToken?.ExpiryDate)"
      >
        {{ 'card.token.expiried' | translate: { fgbdefault: 'EXPIRED' } }}
      </div>
      <a class="text-white d-flex" [routerLink]="cardRouteURL">
        <span class="icon material-icons d-flex align-items-center">chevron_right</span>
      </a>
    </div>
  </div>
</ng-container>

<ng-template #addCard>
  <div
    class="ecash-button d-flex align-items-center bg-glass"
    [ngClass]="{
      'member-card-button justify-content-center': isMemberCard,
      'non-member-button justify-content-between': !isMemberCard,
    }"
  >
    <div *ngIf="!isMemberCard" class="ecash-text">{{ 'member.card.ecash.pay' | translate }}</div>

    <a
      class="btn btn-add d-flex align-item-center"
      [routerLink]="cardRouteURL"
      [ngClass]="{
        'text-white': isMemberCard,
        'btn-primary': !isMemberCard,
      }"
    >
      <span class="icon material-icons pe-2">add_card</span>
      <span class="add-text">
        <ng-container *ngIf="!isMemberCard">{{ 'member.card.ecash.pay.add' | translate }}</ng-container>
        <ng-container *ngIf="isMemberCard">{{ 'member.card.connect.card' | translate }}</ng-container>
      </span>
    </a>
  </div>
</ng-template>
